var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.54 3.602a2.875 2.875 0 013.976 1.084v.002l6.606 11.993a2.875 2.875 0 01-2.515 4.304H5.393a2.874 2.874 0 01-2.516-4.304L9.484 4.686c.249-.449.613-.824 1.056-1.084zM12 4.953a1.125 1.125 0 00-.984.58l-6.61 12-.008.014a1.125 1.125 0 00.984 1.688H18.618a1.125 1.125 0 00.984-1.688l-.009-.015-6.609-11.998a1.128 1.128 0 00-.984-.58z",
    fill: "#121314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 17.539a1.25 1.25 0 11.772 1.148 1.239 1.239 0 01-.772-1.148zM12 7.19a1.26 1.26 0 011.25 1.32l-.5 6.55h-1.51l-.49-6.55A1.271 1.271 0 0112 7.19z",
    fill: "#121314"
  })));
}
export default SvgLarge;